'use client';

import { useEffect } from 'react';

import { reloadOnceForChunkLoad } from '@/lib/errors/chunk-load-recovery';
import { reportClientError } from '@/lib/errors/report-client-error';

/**
 * Root error overlay. Must include <html> and <body> because the root layout
 * is not rendered when this boundary is shown.
 */
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    if (reloadOnceForChunkLoad(error)) {
      return;
    }
    reportClientError({
      message: error.message,
      digest: error.digest,
    });
  }, [error]);

  return (
    <html lang="en">
      <body>
        <div
          style={{
            display: 'flex',
            minHeight: '100vh',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 24,
            fontFamily: 'system-ui, sans-serif',
          }}
        >
          <div style={{ maxWidth: 420, textAlign: 'center' }}>
            <h1 style={{ fontSize: 24, fontWeight: 600 }}>Something went wrong</h1>
            <p style={{ fontSize: 14, color: '#64748b', marginTop: 8 }}>
              An unexpected error occurred. Please try again.
            </p>
            <button
              type="button"
              onClick={() => reset()}
              style={{
                marginTop: 16,
                padding: '8px 16px',
                borderRadius: 8,
                border: '1px solid #cbd5e1',
                background: '#fff',
                cursor: 'pointer',
              }}
            >
              Try again
            </button>
          </div>
        </div>
      </body>
    </html>
  );
}
